export default __webpack_public_path__ + "static/media/range.cdf577a8.png";